import {convertTimeToDecimal} from './convertTimeToDecimal';

export function sunlightPercentage(sunrise, sunset) {
	// Convert times to decimal format
	const sunriseDecimal = convertTimeToDecimal(sunrise);
	const sunsetDecimal = convertTimeToDecimal(sunset);

	const sunlightDuration = sunsetDecimal - sunriseDecimal;
	const sunlightPercentages = new Array(24).fill(0);

	// Calculate sunlight percentages for each hour of the day
	for (let hour = 0; hour < 24; hour++) {
		if (hour / 24 > sunriseDecimal && hour / 24 < sunsetDecimal) {
			sunlightPercentages[hour] = 1;
		}
		if (Math.floor(sunriseDecimal * 24) === hour) {
			// Calculate the exact percentage for the sunrise hour
			sunlightPercentages[hour] = (1 - (sunriseDecimal * 24 - hour));
		}
		if (Math.floor(sunsetDecimal * 24) === hour) {
			// Calculate the exact percentage for the sunset hour
			sunlightPercentages[hour] = (sunsetDecimal * 24 - hour);
		}
	}
	return sunlightPercentages;
}
